import { useEffect } from "react";
import { FileUpload } from "../FileUpload/FileUpload.jsx";
import { useFormDispatch } from "../../FormContext.jsx";
import styles from "../../showroomForm.css";

const DispatchingFileUpload = ({
  validateFile,
  error,
  fieldKey,
  accept,
  formData,
  setFormData,
  description,
  required,
  label,
}) => {
  const dispatch = useFormDispatch();
  const value = formData[fieldKey];

  useEffect(() => {
    if (error) return;
    dispatch({ type: "updateField", [fieldKey]: value });
  }, [value, fieldKey, dispatch, error]);

  return (
    <div className={styles.enhancedCompContainer}>
      <FileUpload
        fieldKey={fieldKey}
        formData={formData}
        setFormData={setFormData}
        validateFile={validateFile}
        error={error}
        accept={accept}
        description={description}
        required={required}
        label={label}
      />
    </div>
  );
};

export default DispatchingFileUpload;
